<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <div
            class="ts-border ts-rounded ts-border-gray-200 ts-border-opacity-20 ts-p-3"
          >
            <div class="row">
              <div class="col-md-6">
                <div class="col-md-12 ts-flex">
                  <label class="col-md-3 col-form-label required">{{
                    $t('termsemester.academicYear')
                  }}</label>
                  <div class="col-md-8">
                    <select
                      class="form-control"
                      :class="{ 'is-invalid': errors.has('ac_year_id') }"
                      v-model.number="model.ac_year_id"
                      @change="getTermOrder()"
                    >
                      <option value="">{{ $t('select') }}</option>
                      <option
                        v-for="(acYear, index) in acYears"
                        :key="index"
                        :value="acYear.ac_year_id"
                      >
                        {{ acYear.ac_year }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      v-if="errors.has('ac_year_id')"
                    >
                      {{ errors.first('ac_year_id') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="col-md-12 ts-flex">
                  <label class="col-form-label required col-md-3">{{
                    $t('termsemester.subProgram')
                  }}</label>
                  <div class="col-md-8">
                    <ts-search-select
                      v-model.number="model.acps_id"
                      :options="subPrograms"
                      @change="getTermOrder"
                    >
                    </ts-search-select>
                    <div class="validate" v-if="errors.has('+')">
                      {{ errors.first('acps_id') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <h1 class="ts-py-2">{{ $t('termsemester.academictermorder') }}</h1>
          <div
            class="ts-border ts-rounded ts-border-gray-200 ts-border-opacity-20 ts-p-3"
          >
            <div class="row form-group">
              <div class="col-md-12">
                <table class="table table-hover ui-table">
                  <thead>
                    <tr>
                      <th class="ts-text-xs ts-whitespace-no-wrap">
                        {{ $t('termsemester.academicTerm') }}
                      </th>
                      <th class="ts-text-xs ts-whitespace-no-wrap">
                        {{ $t('termsemester.termOrder') }}
                      </th>

                      <th clas="ts-text-xs ts-whitespace-no-wrap">
                        {{ $t('termsemester.startDate') }}
                      </th>
                      <th class="ts-text-xs ts-whitespace-no-wrap">
                        {{ $t('termsemester.stopDate') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(sub, index) in model.ac_term_list"
                    :key="index"
                  >
                    <tr>
                      <td
                        class="text-left ts-text-xs text-center"
                        valign="middle"
                      >
                        <ts-input
                          v-model="sub.term_name"
                          style="width: 300px"
                          :class="{ 'is-invalid': errors.has('term_name') }"
                        />
                        <div class="validate" v-if="errors.has('+')">
                          {{ errors.first('term_name') }}
                        </div>
                      </td>
                      <td class="ts-px-2 ts-py-1 ts-w-6 ts-text-center">
                        {{ index + 1 }}
                      </td>

                      <td class="text-left ts-text-xs" valign="middle">
                        <ts-date-picker-input
                          :closeOnSelect="true"
                          v-model="sub.term_start"
                          :class="{ 'is-invalid': errors.has('term_start') }"
                        >
                        </ts-date-picker-input>
                        <div class="validate" v-if="errors.has('+')">
                          {{ errors.first('term_start') }}
                        </div>
                      </td>

                      <td class="text-left ts-text-xs" valign="middle">
                        <ts-date-picker-input
                          :closeOnSelect="true"
                          v-model="sub.term_stop"
                          :class="{ 'is-invalid': errors.has('term_stop') }"
                        >
                        </ts-date-picker-input>
                        <div class="validate" v-if="errors.has('+')">
                          {{ errors.first('term_stop') }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 text-right">
          <hr />
          <ts-button
            class="btn-primary mr-2"
            :waiting="waiting_save_new"
            @click.prevent="saveAddNew"
          >
            {{ $t('save_add_new') }}
          </ts-button>
          <ts-button
            class="btn-primary mr-2"
            @click.prevent="store"
            :waiting="waiting_save"
          >
            {{ $t('save') }}
          </ts-button>
          <ts-button class="btn-default" @click.prevent="$emit('close')">
            {{ $t('cancel') }}
          </ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  name: 'term-semester-create',
  data() {
    return {
      errors: new Errors(),
      waiting_save: false,
      waiting_save_new: false,
      pull_term_order: false,
      loading: false,
      acps_id: [],
      model: {
        ac_year_id: '',
        acps_id: '',
        ac_term_list: []
      }
    }
  },
  created() {
    this.selectDefaultCurrentYear()
  },
  computed: {
    ...mapState('termSemester', ['acYears']),
    subPrograms() {
      return this.$store.state.termSemester.subPrograms.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign,
        number_of_term_per_ac_year: el.number_of_term_per_ac_year
      }))
    }
  },
  methods: {
    ...mapActions('termSemester', ['getExistingTerm']),
    selectDefaultCurrentYear() {
      if (this.acYears.length > 0) {
        let currentYear = this.acYears.filter(y => y.ac_status_id == 1)
        if (currentYear[0]) {
          this.model.ac_year_id = currentYear[0].ac_year_id
        }
      }
    },

    store() {
      this.waiting_save = true
      this.$store
        .dispatch('termSemester/store', this.model)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'term-semester' })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_save = false
        })
    },
    saveAddNew() {
      this.waiting_save_new = true
      this.$store
        .dispatch('termSemester/store', this.model)
        .then(response => {
          this.waiting_save_new = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting_save_new = false
        })
    },

    getTermOrder() {
      const sub = this.subPrograms.find(s => s.value === this.model.acps_id)
      this.model.ac_term_list = []
      if (sub) {
        for (let i = 0; i < sub.number_of_term_per_ac_year; i++) {
          this.model.ac_term_list.push({
            acps_id: this.model.acps_id,
            term_name: '',
            ac_term_id: 0,
            term_order: i + 1,
            term_start: '',
            term_stop: ''
          })
        }
      }
      this.onGetExistingTerm()
    },
    clearInput() {
      this.model.ac_year_id = '',
      this.model.acps_id = '',
      this.model.ac_term_list = []
      this.selectDefaultCurrentYear()
    },
    onGetExistingTerm() {
      if (this.model.ac_year_id && this.model.acps_id) {
        this.loading = true
        this.getExistingTerm({
          filter: {
            acps_id: this.model.acps_id,
            ac_year_id: this.model.ac_year_id
          }
        })
          .then(response => {
            const sorted = response.data.sort((a, b) => {
              return (
                moment(a.term_stop, 'DD-MM-YYYY') -
                moment(b.term_stop, 'DD-MM-YYYY')
              )
            })

            sorted.forEach((el, index) => {
              const row = this.model.ac_term_list[index]
              row.ac_term_id = el.ac_term_id
              row.term_name = el.term_name
              row.term_start = el.term_start
              row.term_stop = el.term_stop
            })
          })
          .finally(() => (this.loading = false))
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('termSemester/RESET_STATE')
      this.$store.commit('termSemester/edit_data', {})
      this.$store.commit('termSemester/GET_SUB_PROGRAM', [])
      this.$store.commit('termSemester/GET_AC_YEAR', [])
    }
    next()
  }
}
</script>
<style lang="css" scoped>
.table > thead > tr > th {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  align-items: center;
}
</style>
